import { render, staticRenderFns } from "./AreaValidation.vue?vue&type=template&id=128a641a&"
import script from "./AreaValidation.vue?vue&type=script&lang=js&"
export * from "./AreaValidation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports